import React from "react";

// Reusable section wrapper component
export default function SectionWrapper({ children }) {
  return (
    <section className="w-full py-16 px-4">
      <div className="max-w-7xl mx-auto">{children}</div>
    </section>
  );
}
